module.exports = __webpack_public_path__ + "img/reference-dellenhotspot.1e831fcc.webp";